<template>
  <div class="container-fluid h-100">
    <div class="content-alliances" id="content-alliances" title="Alianzas" alt="Alianzas">
      <div
        class="row jusify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 ">
        <div class="col-12 col-md-8 col-lg-8 col-xl-8 col-sm-8">
          <h1 class="page_title">
            CATEGORÍAS DE ALIANZAS
          </h1>
        </div>
        <div class="col-12 col-md-10 mt-5">
          <div class="row justify-content-center">
            <router-link
              v-for="item in alliances"
              :key="item.id"
              :to="{ name: route, params: { name: item.name } }"
              class="col-10 col-md-2 card"
            >
              <p class="text-link">{{ item.name }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    data(){
      return {
        route: null,
        arrayCategories: [],
        alliances: {}
      };
    },
    methods: {
      getAlliancesCategories(){
        let app = this;
        axios
        .get("api/get/categories")
        .then(res => {
          app.arrayCategories = res.data.data;
          app.alliances = app.arrayCategories.filter(element => element.status_id == 1);
        })
        .catch(error => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
    },
    mounted(){
      let currentRoute = this.$route.name;
      if(currentRoute == 'listOfAlliancesCategories'){
        this.route = 'alliances';
      } else {
        this.route = 'alliances1';
      }
      this.getAlliancesCategories();
    },
  }
</script>

<style scoped>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.content-alliances {
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
  background-size: cover;
  background-image: url("./../../assets/img/fondo_alianzas.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.page_title {
  font-size: 50px;
  font-family: 'Gotham-UltraItalic', sans-serif;
}
.card{
  background: #1da5df;
  margin: 15px;
  box-shadow: 0px 0px 15px black;
  justify-content: center;
  cursor: pointer;
}
.card:hover{
  transform: scale(1.2);
  transition-duration: 0.3s;
}
.text-link{
  padding-top: 10px;
  font-size: 15px;
  color: white;
  font-family: 'Gotham-UltraItalic', sans-serif;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
  .content-alliances {
    padding-top: 35%;
    padding-bottom: 12%;
    height: 100%;
  }
  .page_title {
    font-size: 40px;
  }
}
</style>